import { useTranslation } from 'react-i18next'
import { Chip, ChipProps } from '@mui/material'
import { CellProps } from 'react-table'

import { OfflineConsultation } from '@/core/offline'

export function StatusCell({ value, row: { original: consultation } }: CellProps<OfflineConsultation, OfflineConsultation['status']>) {
  const { t } = useTranslation()

  let color: ChipProps['color']
  let status: string = value

  switch (value) {
    case 'scheduled':
      color = 'primary'
      if (!!consultation.waitingRoom) status = 'waiting'
      break
    case 'accepted':
    case 'active':
      color = 'success'
      break
    case 'canceled':
    case 'refused':
      color = 'error'
      break
    case 'completed':
      color = 'info'
      break
    default:
      color = 'info'
      break
  }

  return <Chip color={color} label={t(`common:model.consultation.status.${status}.label`)} size="small" variant="filled" />
}
